// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDeleteDialog } from '../../../components/ConfirmDeleteDialog';
import type { DeploymentItem } from '../../../api/deploymentsApi';

interface DeploymentItemDeleteDialogProps {
  item: DeploymentItem | null;
  open: boolean;
  loading?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeploymentItemDeleteDialog = ({
  item,
  open,
  loading = false,
  error = null,
  onConfirm,
  onClose,
}: DeploymentItemDeleteDialogProps) => {
  const { t } = useTranslation();
  if (!item) return null;

  const date = `${item.scheduled_date}${
    item.scheduled_time ? ` ${item.scheduled_time}` : ''
  }`;

  return (
    <ConfirmDeleteDialog
      open={open}
      title={t('Delete this item?')}
      description={t('The item below will be removed from the deployment')}
      details={[
        { label: t('Point of sale'), value: item.store_name, emphasis: true },
        { label: t('Brand'), value: item.brand },
        { label: t('Furniture'), value: item.furniture_name },
        { label: t('Date'), value: date },
      ]}
      loading={loading}
      error={error}
      confirmLabel={t('Delete')}
      cancelLabel={t('Cancel')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
